var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4987,
    cy: 5.88099,
    r: 5.88099,
    fill: "url(#paint0_radial_110_2304)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0954 15.4843C20.0954 21.2919 15.7994 26 10.5001 26C5.20075 26 0.904785 21.2919 0.904785 15.4843C0.904785 9.6766 5.20075 13.8015 10.5001 13.8015C15.7994 13.8015 20.0954 9.6766 20.0954 15.4843Z",
    fill: "url(#paint1_radial_110_2304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_110_2304",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.03015 2.24038) rotate(36.312) scale(13.4779 13.7627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0851008,
    stopColor: "#97D5CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54BAAF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_110_2304",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.57776 14.975) rotate(27.5438) scale(19.9849 17.5348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0851008,
    stopColor: "#97D5CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54BAAF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3);
export default __webpack_public_path__ + "static/media/user3.3d44ad9658ab454980260b23da888e01.svg";
export { ForwardRef as ReactComponent };